module.exports = __webpack_public_path__ + "static/media/car.739fd358.png";